import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

import { trigger, state, style, transition, animate } from '@angular/animations';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';



@Component({
  selector: 'app-ticket-associated-modal',
  templateUrl: './ticket-associated-modal.component.html',
  styleUrls: ['./ticket-associated-modal.component.scss'],
    animations: [
      trigger('slideToggle', [
        state('closed', style({
          height: '0',
          opacity: 0,
          overflow: 'hidden'
        })),
        state('open', style({
          height: '*',
          opacity: 1
        })),
        transition('closed <=> open', animate('300ms ease-in-out'))
      ]),
      trigger('slideInOut', [
          state('void', style({
              opacity: 0,
              transform: 'translateX(-100%)'
          })),
          state('*', style({
              opacity: 1,
              transform: 'translateX(0)'
          })),
          transition('void <=> *', animate('300ms ease-in-out'))
      ])
    ]
})
export class TicketAssociatedModalComponent {
  searchQuery = '';
  selectedTickets: number[] = []; // Lista de IdTicket selecionados
  searchResults: any[] = [];
  showResults = false; 
  isLoading = false;
  public headerForm: FormGroup;

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder, private http: HttpClient,  public router: Router) {
    this.headerForm = this.fb.group({
      searchControl:  [""]
    });
  }

// Verifica se um ticket está selecionado
isSelected(idTicket: number): boolean {
  return this.selectedTickets.includes(idTicket);
}

// Alterna a seleção de um ticket
toggleSelection(idTicket: number): void {
  if (this.isSelected(idTicket)) {
    this.selectedTickets = this.selectedTickets.filter(id => id !== idTicket);
  } else {
    this.selectedTickets.push(idTicket);
  }
}

// Confirma a seleção e passa os IdTickets selecionados
confirmSelection(): void {
  if (this.selectedTickets.length > 0) {
    console.log('Tickets selecionados:', this.selectedTickets);
    this.activeModal.close(this.selectedTickets); // Passa a lista para o componente pai
  }
}

  searchClick()
  {
    const searchControlText = this.headerForm.get('searchControl')?.value;
    if (!searchControlText) {
      console.error('htmlContent control not found');
      return;
    }
    console.log(searchControlText);

    this.http.get<any>(`${environment.apiUrl}/ticket/search/${searchControlText}`, ).subscribe(
      (response) => {
        console.error('Resultado:', response);
        if(response.length == 0)
          alert('Nenhum resultado encontrado.')
        this.searchResults = response;
        this.showResults = true;
      },
      (error) => {
        console.error('Error:', error);
      });
  }

  isSearchControlNotEmpty(): boolean {
    const searchControl = this.headerForm.get('searchControl');
    return searchControl && searchControl.value && searchControl.value.trim() !== '';
}

  closeModal() {
    this.activeModal.dismiss();
  }


  
}
